import { RoleType } from '@ace-clublabs/common-membership-api-types';
import { Button, Icon, Stack, Typography } from '@ace-clublabs/shared-component-library';
import { ROLE_TYPE_MAP } from '../../../utils/stringHelper';

export interface ISelectMemberBladeProps {
  memberName: string;
  memberRole: RoleType;
  className: string;
  onClick: () => void;
  selected: boolean;
}
export const SelectMemberBlade = ({
  memberName,
  memberRole,
  className,
  onClick,
  selected,
}: ISelectMemberBladeProps) => {
  return (
    <Button
      label={
        <Stack direction="column" alignItems="start">
          <Typography variant="b2Medium" data-qm-block="true">
            {memberName}
          </Typography>
          <Typography variant="b3Regular">{ROLE_TYPE_MAP[memberRole]}</Typography>
        </Stack>
      }
      className={className}
      onClick={onClick}
      variant="outlined"
      endIcon={
        selected && (
          <Icon
            className="selected-member-check-icon"
            iconName="circle-check-solid"
            sx={{ fontSize: '1.24rem !important' }}
          />
        )
      }
      sx={{
        borderColor: selected ? '#0C72DF !important' : '#D0D0D0 !important',
        borderWidth: selected ? '2px !important' : '1px !important',
        minWidth: '100%',
        height: '100% !important',
        justifyContent: 'space-between',
        textAlign: 'left',
      }}
    ></Button>
  );
};
